import { render, staticRenderFns } from "./DeclineEventInvitation.vue?vue&type=template&id=533e7a12&scoped=true&"
import script from "./DeclineEventInvitation.vue?vue&type=script&lang=ts&"
export * from "./DeclineEventInvitation.vue?vue&type=script&lang=ts&"
import style0 from "./DeclineEventInvitation.vue?vue&type=style&index=0&id=533e7a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533e7a12",
  null
  
)

export default component.exports